<template>
  <b-card
    v-if="canRead && hasStatus"
    class="mt-1"
    :border-variant="isCompleted ? 'success' : ''"
  >
    <div class="d-flex justify-content-between align-items-center flex-wrap">
      <div>
        <h5 class="mb-25">
          Pré-Entrevista por IA
          <b-badge :variant="statusData.variant" class="ml-50">{{
            statusData.label
          }}</b-badge>
        </h5>
        <div class="text-muted small">
          <span v-if="status.sent_at">Enviada em {{ status.sent_at | dateTime }}</span>
          <span v-if="status.accessed_at"> · Acessada em {{ status.accessed_at | dateTime }}</span>
          <span v-if="status.completed_at"> · Concluída em {{ status.completed_at | dateTime }}</span>
          <span v-if="status.resent_count"> · {{ status.resent_count }} reenvio(s)</span>
        </div>
      </div>
    </div>

    <!-- CTA destacada quando concluída -->
    <b-button
      v-if="isCompleted"
      variant="success"
      block
      size="lg"
      class="mt-1"
      @click="goToResults"
    >
      <feather-icon icon="FileTextIcon" size="18" class="mr-50" />
      Ver respostas e resumo da Pré-Entrevista por IA
    </b-button>
  </b-card>
</template>

<script>
import { BCard, BBadge, BButton } from "bootstrap-vue";
import { mapActions } from "vuex";
import * as types from "../store/types";
import { READ_ACTION, AI_PRE_INTERVIEW } from "@/constants/resources";

const AI_STATUS_MAP = {
  nao_enviada: { label: "Não enviada", variant: "secondary" },
  enviada: { label: "Enviada", variant: "info" },
  acessada: { label: "Acessada", variant: "primary" },
  em_preenchimento: { label: "Em preenchimento", variant: "warning" },
  concluida: { label: "Concluída", variant: "success" },
  expirada: { label: "Expirada", variant: "dark" },
  erro: { label: "Erro", variant: "danger" },
  reaberta: { label: "Reaberta", variant: "info" },
};

export default {
  name: "AiPreInterviewStatus",
  components: { BCard, BBadge, BButton },
  props: {
    customer: {
      type: Object,
    },
  },
  data() {
    return {
      status: null,
    };
  },
  computed: {
    canRead() {
      return this.$can(READ_ACTION, AI_PRE_INTERVIEW);
    },
    hasStatus() {
      return this.status && this.status.status !== "nao_enviada";
    },
    statusData() {
      const s = this.status?.status || "nao_enviada";
      return AI_STATUS_MAP[s] || AI_STATUS_MAP.nao_enviada;
    },
    isCompleted() {
      // Tem resultados (mesmo após reaberta): mostra o CTA/borda de resultados.
      return !!(this.status && this.status.completed_at);
    },
  },
  mounted() {
    if (this.canRead && this.customer?.token) {
      this.getStatus(this.customer.token)
        .then((resp) => {
          this.status = resp.data;
        })
        .catch(() => {});
    }
  },
  methods: {
    ...mapActions({
      getStatus: types.GET_AI_PRE_INTERVIEW_STATUS,
    }),
    goToResults() {
      this.$router.push({
        name: "ai-pre-interview-results",
        params: { id: this.customer?.id },
      });
    },
  },
};
</script>
